import { VideoAssetBody, VideoAssetResponse } from '../../../API';
import { useVideoAssetsAPI } from '../../../hooks/API/VideoAssets/useVideoAssetsAPI';
import { CreateDataManager, DataManagerReturnType } from '../../DataManager';
import { VideoAssetsHook, VideoAssetsHookReturnType } from './VideoAssetsHook';
import { VideoAssetsState, VideoAssetStateReturnType } from './VideoAssetsState';

export type VideoAssetsDataManagerType = {
  state: VideoAssetStateReturnType;
  hook: VideoAssetsHookReturnType;
};

export interface VideoAssetsDataManagerReturnType extends DataManagerReturnType<VideoAssetResponse, VideoAssetBody> {
  state: VideoAssetsDataManagerType['state'];
  hook: () => VideoAssetsDataManagerType['hook'];
}

export const videoAssetSortFunction = (a: VideoAssetResponse, b: VideoAssetResponse): number => {
  if (!a.createdDate || !b.createdDate) return 0;
  if (a.createdDate < b.createdDate) {
    return -1;
  }
  if (a.createdDate > b.createdDate) {
    return 1;
  }
  return 0;
};

export const VideoAssetsDataManager = CreateDataManager<
  VideoAssetResponse,
  VideoAssetBody,
  VideoAssetsDataManagerReturnType
>({
  name: 'videoAssets',
  idField: 'id',
  stateInitializer: VideoAssetsState,
  hookInitializer: VideoAssetsHook,
  useApiHook: useVideoAssetsAPI,
  paginationLimit: 500,
  bucketIdToQueryParams(id) {
    return [id];
  },
  getRecordBucketIds(record) {
    return [(record as VideoAssetResponse).assetType];
  },
  sortFunctionInitializer: () => videoAssetSortFunction,
  toString: (asset) => asset.assetName
});
